'use strict';

module.exports = function (obj, props) {
  return props.reduce(function (selection, prop) {
    if (typeof obj[prop] === 'undefined') {
      return selection;
    }

    selection[prop] = obj[prop];
    return selection;
  }, {});
};


//////////////////
// WEBPACK FOOTER
// ./~/@sanity/client/lib/util/pick.js
// module id = 274
// module chunks = 0